import { clearAllEditableFieldErrors } from '../store';
export var navigateToStep = function (params) {
    params.store.dispatch(clearAllEditableFieldErrors());
    params.navigate(params.stepPathname);
};
